var _rect, _rect2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 40",
    width: 135,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    rx: 6,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 5.5,
    stroke: "#A6A6A6",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 7)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA771"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1.3 1.1a2.1 2.1 0 0 0-.7 1.7v20.4c0 .7.3 1.3.7 1.7l.1.1L12.9 13.5v-.3L1.4 1z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 17.4l-3.8-3.9v-.3l3.8-3.9.1.1 4.5 2.6c1.3.7 1.3 1.9 0 2.6l-4.5 2.6-.1.2z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 17.2L12.9 13.3 1.3 24.9c.4.5 1.1.5 1.9.1l13.6-7.8",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 9.4L3.2 1.6C2.4 1.1 1.7 1.2 1.3 1.7L12.9 13.3l3.9-3.9z",
    fill: "url(#d)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 7.5,
    x: 40,
    y: 13,
    letterSpacing: "0.07em",
    "text-transform": "uppercase"
  }, "GET IT ON"), /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 13,
    fontWeight: "bold",
    x: 40,
    y: 28,
    letterSpacing: "-0.02em"
  }, "Google Play"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGooglePlay);
export default __webpack_public_path__ + "static/media/badge-google-play.982d94a89dcc1c52dee4ddb735253c30.svg";
export { ForwardRef as ReactComponent };